import { useGetBonusesQuery } from '@/queries/useGetBonusesQuery';

export const useBonuses = () => {
  const { data: bonusesData, isLoading } = useGetBonusesQuery();

  if (isLoading) {
    return { bonusesData: [], isLoading };
  }

  return { bonusesData };
};
